import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import LogoIdk from '../assets/images/logoIdk.webp';

const NavBar = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const mobileMenuId = 'primary-navigation';
    const dropdownId = 'services-dropdown';
    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Escape') {
            setIsDropdownOpen(false);
            setIsMobileMenuOpen(false);
        }
    }, []);

    // Lock body scroll when mobile menu is open
    useEffect(() => {
        if (isMobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobileMenuOpen]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [handleKeyDown]);

    const servicios = [
        { path: '/ingenieria', label: 'Ingeniería y proyectos' },
        { path: '/tableros', label: 'Armado de tableros eléctricos' },
        { path: '/termografia', label: 'Termografía y mediciones' },
        { path: '/mantenimiento', label: 'Mantenimiento' },
        { path: '/instalaciones', label: 'Instalaciones' },
        { path: '/capacitacion', label: 'Capacitación' }
    ];

    return (
        <>
            <nav className="modern-navbar">
                <div className="navbar-container">
                    <div className="navbar-logo">
                        <Link to='/'>
                            <img src={LogoIdk} alt='Logo Idelek' />
                        </Link>
                    </div>

                    <button
                        className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        aria-label="Toggle navigation"
                        aria-expanded={isMobileMenuOpen}
                        aria-controls={mobileMenuId}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    <ul
                        id={mobileMenuId}
                        className={`navbar-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}
                    >
                        <li className="nav-item">
                            <Link className="nav-link" to='/' onClick={() => setIsMobileMenuOpen(false)}>
                                Inicio
                            </Link>
                        </li>

                        <li
                            className="nav-item dropdown-container"
                            onMouseEnter={() => setIsDropdownOpen(true)}
                            onMouseLeave={() => setIsDropdownOpen(false)}
                            onFocus={() => setIsDropdownOpen(true)}
                            onBlur={(event) => {
                                if (!event.currentTarget.contains(event.relatedTarget)) {
                                    setIsDropdownOpen(false);
                                }
                            }}
                        >
                            <button
                                className={`nav-link dropdown-trigger ${isDropdownOpen ? 'active' : ''}`}
                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                aria-expanded={isDropdownOpen}
                                aria-controls={dropdownId}
                                aria-haspopup="true"
                                type="button"
                            >
                                Servicios
                                <svg
                                    className={`dropdown-arrow ${isDropdownOpen ? 'rotate' : ''}`}
                                    width="12"
                                    height="8"
                                    viewBox="0 0 12 8"
                                    fill="none"
                                >
                                    <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </button>

                            <ul
                                id={dropdownId}
                                className={`custom-dropdown ${isDropdownOpen ? 'show' : ''}`}
                            >
                                {servicios.map((servicio, index) => (
                                    <li key={index} style={{ '--item-index': index }}>
                                        <Link
                                            to={servicio.path}
                                            onClick={() => {
                                                setIsDropdownOpen(false);
                                                setIsMobileMenuOpen(false);
                                            }}
                                        >
                                            {servicio.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </li>

                        <li className="nav-item">
                            <Link className="nav-link" to='/clientes' onClick={() => setIsMobileMenuOpen(false)}>
                                Clientes
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link className="nav-link" to='/contacto' onClick={() => setIsMobileMenuOpen(false)}>
                                Contacto
                            </Link>
                        </li>
                    </ul>
                </div>
                {/* Overlay para cerrar el menú móvil */}
                {isMobileMenuOpen && (
                    <div
                        className="mobile-menu-overlay active"
                        onClick={() => setIsMobileMenuOpen(false)}
                    />
                )}
            </nav>
            <div id='progress'></div>
        </>
    );
}

export default NavBar;
